import {Route} from '@angular/router';
import {dashboardResolver, initialDataResolver} from 'app/app.resolvers';
import {AuthGuard} from 'app/core/auth/guards/auth.guard';
import {NoAuthGuard} from 'app/core/auth/guards/noAuth.guard';
import {LayoutComponent} from 'app/layout/layout.component';
import {AuthUtils} from './core/auth/auth.utils';
import {UserService} from "./core/user/user.service";
import {ProfileComponent} from "./modules/admin/users/profile/product-profile/profile.component";
import {CanDeactivateGuard} from "./core/auth/guards/canDeactivate.guard";
import {DetailsComponent} from "./modules/admin/users/details/details.component";
import {UploadDocumentsComponent} from "./modules/admin/users/profile/documents/upload/upload-attachments.component";
import {DocumentsComponent} from "./modules/admin/users/profile/documents/documents.component";
import {
    CanDeactivateAttachmentDetails
} from "./modules/admin/users/profile/documents/attachments.guards";
import {AttachmentDetailsComponent} from "./shared/components/attachment-details/details.component";
import {ProfileSheetComponent} from "./modules/admin/users/profile-sheet/profile-sheet.component";
import {YearlyPlansPageComponent} from "./modules/hr/absences-leave-management/absences-leave-management.component";
import {
    AbsenceLeaveDetailsComponent
} from "./modules/hr/absences-leave-management/absence-leave-details/details.component";
import {HolidaysComponent} from "./modules/hr/holidays-management/holidays.component";
import {CanDeactivateAbsenceDetails} from "./modules/hr/absences-leave-management/absences-leave.guards";
import {UtilizationDashboardComponent} from "./shared/components/utilization-dashboard/utilization-dashboard.component";

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to ''
    {
        path: '',
        canActivate: [AuthGuard],
        resolve: { dashboard: dashboardResolver }, // Use the resolver here
        pathMatch: 'full',
        component: LayoutComponent,
    },

    // Redirect signed in user to the '/core/dashboard'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: '' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            // {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/forgot-password/forgot-password.routes'
                    ),
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/reset-password/reset-password.routes'
                    ),
            },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.routes'),
            },
            // {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.routes'),
            },
            // {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ],
    },

    // Landing routes
    // {
    //     path: '',
    //     component: LayoutComponent,
    //     data: {
    //         layout: 'empty'
    //     },
    //     children: [
    //         {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
    //     ]
    // },

    // Core routes
    {
        path: 'core',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('app/modules/admin/dashboard/dashboard.routes'),
                data: { moduleId: AuthUtils.MODULE_CORE },
            },
            {
                path: 'roles',
                loadChildren: () =>
                    import('app/modules/admin/roles/roles.routes'),
                data: { moduleId: AuthUtils.MODULE_ROLES },
            },
            {
                path: 'users',
                loadChildren: () =>
                    import('app/modules/admin/users/users.routes'),
                data: { moduleId: AuthUtils.MODULE_USERS },
            },
            {
                path: 'customers',
                loadChildren: () =>
                    import('app/modules/admin/customer/customer.routes'),
                data: { moduleId: AuthUtils.MODULE_CUSTOMERS },
            },
            // {path: 'partners', loadChildren: () => import('app/modules/admin/partners/partners.routes'), data: { moduleId: AuthUtils.MODULE_PARTNERS }},
            {
                path: 'settings',
                loadChildren: () =>
                    import('app/modules/admin/settings/settings.routes'),
            },
            {
                path: 'user-profile',
                data: { useCurrentUser: true },
                component: ProfileComponent,
                children: [
                    { path: 'home', redirectTo: 'documents' },
                    {
                        path: 'settings',
                        loadChildren: () =>
                            import(
                                'app/modules/admin/settings/settings.routes'
                            ),
                    },
                    // {
                    //     path: 'documents',
                    //     children: [
                    //         {
                    //             path: 'upload',
                    //             canDeactivate: [CanDeactivateGuard],
                    //             canActivate: [AuthGuard],
                    //             // data: {
                    //             //     module: AuthUtils.MODULE_SERVICE_WORK_ORDERS,
                    //             //     requiredPermissions: ['edit_work_orders'],
                    //             // },
                    //             component: UploadDocumentsComponent
                    //         },
                    //         {
                    //             path: '',
                    //             canDeactivate: [CanDeactivateGuard],
                    //             component: DocumentsComponent,
                    //             children: [
                    //                 {
                    //                     path: ':id',
                    //                     canDeactivate: [CanDeactivateAttachmentDetails],
                    //                     component: AttachmentDetailsComponent,
                    //                 }
                    //             ]
                    //         }
                    //     ]
                    // }
                ],
            },
            {
                path: 'system-settings',
                loadChildren: () =>
                    import('app/modules/admin/system-settings/settings.routes'),
                data: { moduleId: AuthUtils.MODULE_SYSTEM_SETTINGS },
            },
            // {path: 'companies', loadChildren: () => import('app/modules/admin/companies/companies.routes')},
        ],
    },

    // Product management routes
    {
        path: 'mng',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('app/modules/admin/dashboard/dashboard.routes'),
                data: { moduleId: AuthUtils.MODULE_MANAGEMENT },
            },
            // {path: 'production-statuses', loadChildren: () => import('app/modules/mng/production-statuses/production-statuses.routes'), data: { moduleId: AuthUtils.MODULE_PRODUCTION_STATUSES }},
            {
                path: 'vehicles',
                loadChildren: () =>
                    import('app/modules/mng/vehicles/vehicles.routes'),
                data: { moduleId: AuthUtils.MODULE_VEHICLES },
            },
            // {path: 'work-types', loadChildren: () => import('app/modules/mng/work_types/work_types.routes'), data: { moduleId: AuthUtils.MODULE_WORK_TYPES }},
            // {path: 'tax-rates', loadChildren: () => import('app/modules/mng/tax-rates/tax-rates.module').then(m => m.TaxRatesModule), data: { moduleId: AuthUtils.MODULE_TAX_RATES }},
            // {
            //     path: 'documents',
            //     data: {
            //         // moduleId: AuthUtils.MODULE_DOCUMENTS
            //     },
            //     children: [
            //         {
            //             path: '',
            //             canDeactivate: [CanDeactivateGuard],
            //             component: DocumentsComponent,
            //             children: [
            //                 {
            //                     path: ':id',
            //                     canDeactivate: [CanDeactivateAttachmentDetails],
            //                     component: AttachmentDetailsComponent,
            //                 }
            //             ]
            //         }
            //     ]
            // },
            {
                path: 'user-profile',
                data: { useCurrentUser: true },
                component: ProfileComponent,
                children: [
                    { path: 'home', redirectTo: 'documents' },
                    {
                        path: 'settings',
                        loadChildren: () =>
                            import(
                                'app/modules/admin/settings/settings.routes'
                            ),
                    },
                    // {
                    //     path: 'documents',
                    //     children: [
                    //         {
                    //             path: 'upload',
                    //             canDeactivate: [CanDeactivateGuard],
                    //             canActivate: [AuthGuard],
                    //             // data: {
                    //             //     module: AuthUtils.MODULE_SERVICE_WORK_ORDERS,
                    //             //     requiredPermissions: ['edit_work_orders'],
                    //             // },
                    //             component: UploadDocumentsComponent
                    //         },
                    //         {
                    //             path: '',
                    //             canDeactivate: [CanDeactivateGuard],
                    //             component: DocumentsComponent,
                    //             children: [
                    //                 {
                    //                     path: ':id',
                    //                     canDeactivate: [CanDeactivateAttachmentDetails],
                    //                     component: AttachmentDetailsComponent,
                    //                 }
                    //             ]
                    //         }
                    //     ]
                    // }
                ],
            },
        ],
    },

    // Human resources routes
    {
        path: 'hr',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('app/modules/admin/dashboard/dashboard.routes'),
                data: { moduleId: AuthUtils.MODULE_HR_LEAVE_MANAGEMENT },
            },
            {
                path: 'leave-management',
                component: YearlyPlansPageComponent,
                data: { moduleId: AuthUtils.MODULE_LEAVE_MANAGEMENT },
                children: [
                    {
                        path: ':id',
                        canDeactivate: [CanDeactivateAbsenceDetails],
                        component: AbsenceLeaveDetailsComponent,
                    },
                ],
            },
            {
                path: 'holidays-management',
                data: { moduleId: AuthUtils.MODULE_HOLIDAYS_MANAGEMENT },
                loadChildren: () =>
                    import(
                        'app/modules/hr/holidays-management/holidays.routes'
                    ),
            },
            {
                path: 'user-profile',
                data: { useCurrentUser: true },
                component: ProfileComponent,
                children: [
                    { path: 'home', redirectTo: 'documents' },
                    {
                        path: 'settings',
                        loadChildren: () =>
                            import(
                                'app/modules/admin/settings/settings.routes'
                            ),
                    },
                    // {
                    //     path: 'documents',
                    //     children: [
                    //         {
                    //             path: 'upload',
                    //             canDeactivate: [CanDeactivateGuard],
                    //             canActivate: [AuthGuard],
                    //             // data: {
                    //             //     module: AuthUtils.MODULE_SERVICE_WORK_ORDERS,
                    //             //     requiredPermissions: ['edit_work_orders'],
                    //             // },
                    //             component: UploadDocumentsComponent
                    //         },
                    //         {
                    //             path: '',
                    //             canDeactivate: [CanDeactivateGuard],
                    //             component: DocumentsComponent,
                    //             children: [
                    //                 {
                    //                     path: ':id',
                    //                     canDeactivate: [CanDeactivateAttachmentDetails],
                    //                     component: AttachmentDetailsComponent,
                    //                 }
                    //             ]
                    //         }
                    //     ]
                    // }
                ],
            },
        ],
    },

    // Order & Quote management routes
    {
        path: 'omng',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('app/modules/omng/dashboard/omng-dashboard.routes'),
                data: { moduleId: AuthUtils.MODULE_QUOTE_ORDER_MANAGEMENT },
            },
            // {path: 'quotes', loadChildren: () => import('app/modules/omng/quotes/quotes.routes'), data: { moduleId: AuthUtils.MODULE_QUOTES }},
            // {path: 'invoices', loadChildren: () => import('app/modules/omng/invoices/invoices.routes'), data: { moduleId: AuthUtils.MODULE_INVOICES }},
            // {path: 'payments', loadChildren: () => import('app/modules/omng/payments/payments.routes'), data: { moduleId: AuthUtils.MODULE_PAYMENTS }},
            // {path: 'external-contractors', loadChildren: () => import('app/modules/mng/external-contractors/external-contractors.routes'), data: { moduleId: AuthUtils.MODULE_EXTERNAL_CONTRACTORS }},
            {
                path: 'projects',
                loadChildren: () =>
                    import('app/modules/omng/projects/projects.routes'),
                data: { moduleId: AuthUtils.MODULE_PROJECTS },
            },
            {
                path: 'utilization-overview',
                component: UtilizationDashboardComponent,
                data: { moduleId: AuthUtils.MODULE_PROJECTS_PLANNING_MODULE },
            },
            // {path: 'tasks', loadChildren: () => import('app/modules/omng/tasks/tasks.routes'), data: { moduleId: AuthUtils.MODULE_PROJECTS }},
            // {path: 'work-order-groups', loadChildren: () => import('app/modules/omng/work-order-groups/work-order-groups.routes'), data: { moduleId: AuthUtils.MODULE_ORDERS }},
            // {path: 'work-orders', loadChildren: () => import('app/modules/omng/work-orders/work-orders.routes'), data: { moduleId: AuthUtils.MODULE_WORK_ORDERS }},
            {
                path: 'user-profile',
                data: { useCurrentUser: true },
                component: ProfileComponent,
                children: [
                    { path: 'home', redirectTo: 'documents' },
                    {
                        path: 'settings',
                        loadChildren: () =>
                            import(
                                'app/modules/admin/settings/settings.routes'
                            ),
                    },
                    // {
                    //     path: 'documents',
                    //     children: [
                    //         {
                    //             path: 'upload',
                    //             canDeactivate: [CanDeactivateGuard],
                    //             canActivate: [AuthGuard],
                    //             // data: {
                    //             //     module: AuthUtils.MODULE_SERVICE_WORK_ORDERS,
                    //             //     requiredPermissions: ['edit_work_orders'],
                    //             // },
                    //             component: UploadDocumentsComponent
                    //         },
                    //         {
                    //             path: '',
                    //             canDeactivate: [CanDeactivateGuard],
                    //             component: DocumentsComponent,
                    //             children: [
                    //                 {
                    //                     path: ':id',
                    //                     canDeactivate: [CanDeactivateAttachmentDetails],
                    //                     component: AttachmentDetailsComponent,
                    //                 }
                    //             ]
                    //         }
                    //     ]
                    // }
                ],
            },
        ],
    },

    // Error routes
    {
        path: 'error',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: '404',
                loadChildren: () =>
                    import('app/modules/error/error-404/error-404.routes'),
            },
            {
                path: '500',
                loadChildren: () =>
                    import('app/modules/error/error-500/error-500.routes'),
            },
        ],
    },
    {
        path: '**',
        redirectTo: 'error/404',
    },
];
